import React, { FC } from 'react';

import { fc } from 'i18n';

import { Controls } from './controls';
import { AssetForm } from './asset-form';
import { ConfirmModal } from './confirm-modal';
import { Table } from 'components/organisms/table';
import { VehicleMonitoringFooter } from './footer';
import { useVehiclesMonitoring } from 'hooks/vehicles-monitoring/useVehiclesMonitoring';

import styles from './styles.module.css';

export const VehiclesMonitoring: FC = () => {
  const {
    isFormModal,
    isConfirmModal,
    controlProps,
    tableProps,
    formProps,
    confirmProps,
    footerProps,
  } = useVehiclesMonitoring();

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.header}>{fc('airside vehicles monitoring')}</div>
        <Controls {...controlProps} />
        <Table {...tableProps} />
        {!!tableProps.data?.length && <VehicleMonitoringFooter {...footerProps} />}
      </div>
      {isFormModal && <AssetForm {...formProps} />}
      {isConfirmModal && <ConfirmModal {...confirmProps} />}
    </div>
  );
};
